import Layout from '../layout.vue'
import SurveyList from './list.vue'
import SurveyEditor from './editor.vue'

const basePath = '/v-admin/crm-management/survey'

export default {
  path: `${basePath}/list`,
  component: Layout,
  meta: {
    permission: ['PERM_CANDIDATE_SURVEY_MANAGEMENT', 'PREMIUM_PREFERENCE_SURVEY_MANAGEMENT'],
    titleI18nKey: 'admin.crm.survey.title.list',
    menu: {
      labelI18nKey: 'admin.crm.survey.menu'
    }
  },
  children: [
    {
      name: 'crmSurveyList',
      path: '',
      component: SurveyList,
      meta: {
        titleI18nKey: 'admin.crm.survey.title.list',
        breadcrumb: { hidden: true }
      }
    },
    {
      name: 'editCrmSurvey',
      path: `${basePath}/edit/:surveyId`,
      component: SurveyEditor,
      meta: {
        titleI18nKey: 'admin.crm.survey.title.edit',
        isEditMode: true
      }
    }
  ]
}
